import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, FormControlProps } from '@material-ui/core';

export enum RosteringType {
  DISTRICT = 'district',
  PERSONAL = 'personal'
}

export type Props = Omit<FormControlProps, 'onChange'> & {
  value: string;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

const OPTIONS = [
  { value: RosteringType.DISTRICT, label: 'rosteringTypeDistrictOption' },
  { value: RosteringType.PERSONAL, label: 'rosteringTypePersonalOption' }
];

const RosteringTypeSelectInput = ({ value, onChange, ...formControlProps }: Props) => {
  const { t } = useTranslation('AdminRosterManagement');

  return (
    <FormControl {...formControlProps}>
      <Select
        id="rostering-type-select"
        variant="outlined"
        value={value}
        onChange={onChange}
        displayEmpty
        renderValue={selected => {
          if (!selected) return t('rosteringTypePlaceholder');
          const selectedOption = OPTIONS.find(option => option.value === selected);
          return selectedOption ? t(selectedOption.label) : '';
        }}
      >
        {OPTIONS.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RosteringTypeSelectInput;
